import styled from "styled-components";

export const TabContainer = styled.div`
  margin-top: 1.5%;
  width: 90%;
  margin-bottom: 1.5%;

  .MuiTab-root {
    font-weight: 400;
    text-transform: none;
    min-width: 150px;
    transition: color 0.3s ease-in-out, text-shadow 0.3s ease-in-out;
    color: #838081;
    background-color: transparent !important;
    box-shadow: none !important;

    &:hover {
      text-shadow: 0px 0px 8px #fe2f67;
      background-color: transparent !important;
    }
  }

  .Mui-selected {
    font-weight: 600;
    color: #fe2f67 !important;
    background-color: transparent !important;
    box-shadow: none !important;
    text-shadow: 0px 0px 8px #fe2f67;
  }
`;

export const PostTitle = styled.h2`
  margin-top: 1.5%;
  margin-bottom: 1.5%;
  font-size: 1.25rem;
  font-weight: 600;
  position: relative;

  &::after {
    content: "";
    display: block;
    height: 3px;
    background: #fe2f67;
    margin-top: 6px;
    border-radius: 2px;
  }
`;